import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { CashTransactionList } from 'features/transactions/components/CashTransactionList';
import { Layout } from '../../../features/common/components/Layout';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { isAdminOrSuperAdmin } from '../../../features/auth/helpers';
import { PageNotAllowedForMarket } from '../../../features/common/components/PageNotAllowedForMarket';
import { isItauVN } from 'features/common/helpers';

export const CashTransactionPage = (): JSX.Element => {
	const { auth } = useSelector((state: RootState) => state);
	if (!isAdminOrSuperAdmin(auth.user)) return <></>;

	const ItauVN = isItauVN(auth.country);

	return (
		<Layout>
			<Container component="main" maxWidth="xl">
				{ItauVN ? (
					<PageNotAllowedForMarket />
				) : (
					<Box sx={{ pt: 3 }}>
						<Typography variant="h5" fontWeight="bold" color="primary" textAlign="center" mb={3}>
							Transacciones Cash
						</Typography>
						<CashTransactionList />
					</Box>
				)}
			</Container>
		</Layout>
	);
};
